import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { ClientOppDescription } from '../../models/cases/clientOppDescription';

@Component({
  selector: 'app-description-create-edit',
  templateUrl: './description-create-edit.component.html',
  styleUrls: ['./description-create-edit.component.scss']
})
export class DescriptionCreateEditComponent implements OnInit {

  public description: ClientOppDescription;

  @ViewChild('descriptionModal') descriptionModal;
  @Output() submit: EventEmitter<ClientOppDescription> = new EventEmitter<ClientOppDescription>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: FilesApiService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(description: ClientOppDescription) {
    this.description = Object.assign(new ClientOppDescription(), description);
    this.modalRef = this.modalService.open(this.descriptionModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.description.id) {
      this.spinner.show();
      this.api.updateDescription(this.description).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    } else {
      this.spinner.show();
      this.api.createDescription(this.description).subscribe(
        c => {
          this.spinner.hide();
          this.submit.emit(c);
        }
      )
    }
  }

}


